import Api from "../../axios"

export const getTotalHoursMissingEntry= async ({id,date})=>{
    return await Api.get(`/total_hours?employee_id=${id}&date=${date}`)
}